import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

import { SOURCES } from '@skyscanner-internal/global-components/__internal/marketing-consent';
import {
  fetchCultureSelectorData,
  getSessionHandoffToken,
  persistUserSessionData,
  useCultureSelectorData,
} from '@skyscanner-internal/global-components/culture-selector/helpers';
import Header from '@skyscanner-internal/global-components/header';
import { loginModalInit } from '@skyscanner-internal/global-components/header/helpers';
import { SubscriptionClient } from '@skyscanner-internal/global-components/login-form/helpers';
import logger from 'saddlebag-logger';
import { isLoggedIn, getProfilePicture } from 'saddlebag-user-management';

function HeaderWrapper({ headerProps, isPreReleasedLocales }) {
  const newProps = { ...headerProps };
  const [isLoginFormVisible, setIsLoginFormVisible] = useState(false);
  const subscriptionClient = new SubscriptionClient();

  let authClient;

  if (typeof window !== 'undefined') {
    newProps.logger = logger;
    newProps.userLoggedIn = isLoggedIn();

    /* eslint-disable-next-line global-require */
    const { default: AuthClient } = require('@skyscanner/auth-client');
    authClient = new AuthClient({
      market: newProps.market,
      locale: newProps.locale,
      env: headerProps.isProductionEnv ? 'production' : 'development',
      authConsumer: 'lyrebird',
    });
  }

  useEffect(() => {
    loginModalInit({
      setLoginFormVisible: (visible) => setIsLoginFormVisible(visible),
    });
  }, []);

  const { currencies, enMarkets, isFetching, locales, markets, onCultureSelectorButtonClick } = useCultureSelectorData(
    fetchCultureSelectorData,
    newProps.locale,
    isPreReleasedLocales,
  );

  const changeLoginFormVisibility = ({ shouldBeOpen }) => setIsLoginFormVisible(shouldBeOpen);

  newProps.cultureSelectorProps.currencies = currencies;
  newProps.cultureSelectorProps.markets = markets;
  newProps.cultureSelectorProps.locales = locales;
  newProps.cultureSelectorProps.enMarkets = enMarkets;
  newProps.cultureSelectorProps.persistUserSessionDataFn = persistUserSessionData;
  newProps.cultureSelectorProps.getSessionHandoffTokenFn = getSessionHandoffToken;
  newProps.loginFormProps = {
    ...headerProps.loginFormProps,
    authClient,
    isOpen: isLoginFormVisible,
    onVisibilityChange: changeLoginFormVisibility,
    subscriptionClient,
    source: SOURCES.HEADER,
    consumer: 'lyrebird',
  };

  return (
    <Header
      {...newProps}
      getProfilePicture={getProfilePicture}
      onCultureSelectorButtonClick={onCultureSelectorButtonClick}
      isFetchingCultureSelectorData={isFetching}
    />
  );
}

HeaderWrapper.propTypes = {
  // Types for the header are defined in TS and are too complex to be robustly defined here
  // eslint-disable-next-line react/forbid-prop-types
  headerProps: PropTypes.any.isRequired,
  isPreReleasedLocales: PropTypes.bool.isRequired,
};

export default HeaderWrapper;
